module.exports = __webpack_public_path__ + "img/logo-caja.ed85bd9e.png";